import { decodeUploadFileName, shortFileNameParts } from '@numeo/types-core'

/**
 * A document's file name as every Box Truck document chip shows it — My Drivers, Driver Verifications and the
 * Profiles cards: up to ten characters of the name, then the extension after a gap, and the full name on hover.
 *
 * A file name is whatever the uploader's phone called it: a 40-character screenshot name, a UUID from the iOS photo
 * picker. Shown whole, it pushed the chip past its column. The extension sits apart and never shrinks — it is what
 * tells a photo from a PDF — while the name also gives way to a narrow column instead of overflowing it.
 *
 * Names stored before uploads decoded them are garbled (`Ð¡Ð½Ð¸Ð¼Ð¾Ðº.png`, or a phone's `%D0%A1...png`);
 * `decodeUploadFileName` shows them as uploaded and leaves a correct name alone.
 */
export const DocumentFileName = ({ fileName }: { fileName: string }) => {
    const readable = decodeUploadFileName(fileName)
    const { name, extension, cut } = shortFileNameParts(readable)
    return (
        <span title={readable} className="inline-flex min-w-0 max-w-52 whitespace-nowrap">
            <span className="truncate">{name}</span>
            {extension && <span className={cut ? 'ml-1 shrink-0' : 'shrink-0'}>{extension}</span>}
        </span>
    )
}
